import configs from 'configs';
import { REDIRECT_ROUTE } from 'define';
import { useActions } from 'hooks/useActions';
import { sendGaEvent } from 'methods/ga';
import { useAuth } from 'providers/Auth';
import { useToast } from 'providers/Toast';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getOrCreateUser } from 'store/actions/auth';
import { getSeries, linkSeries } from 'store/actions/series';
import { GA_EVENT_TYPE } from '../../define';
import { flattenSeriesTree } from './method';

const { basename } = configs;

export const Series = () => {
    const toast = useToast();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [series, setSeries] = useState([]);
    const [actionGetSeries, actionLinkSeries, actionGetOrCreateUser] = useActions([getSeries, linkSeries, getOrCreateUser]);
    const {
        auth: { accessToken, userId }
    } = useAuth();

    const newSeriesId = searchParams.get('id');
    const newWallpaperId = searchParams.get('wallpaper');

    useEffect(() => {
        if (!series.length) {
            const redirect = () => navigate(`${basename}${REDIRECT_ROUTE}`, { replace: true });

            const handleGetSeries = async () => {
                const { data } = await actionGetSeries();
                const flattenSeries = flattenSeriesTree(data);

                if (!flattenSeries.length) {
                    toast.danger('目前沒有任何系列');
                    redirect();
                }

                setSeries(flattenSeries);
            };

            handleGetSeries();
        }
    }, [actionGetSeries, series, navigate, toast]);

    useEffect(() => {
        if (!series.length) return;

        sendGaEvent(userId, GA_EVENT_TYPE.VIEW_WALLPAPEPR_SERIES_PAGE, { _label: `/${newSeriesId}` });

        const redirect = () => navigate(`${basename}${REDIRECT_ROUTE}?id=${newWallpaperId}`, { replace: true });

        const handleSeriesLink = async () => {
            await actionGetOrCreateUser(userId, JSON.stringify({ accessToken, lineId: userId }));

            if (!newSeriesId) return redirect();

            const res = await actionLinkSeries(userId, newSeriesId);

            const seriesTitle = series.find((s) => s.id === newSeriesId)?.title ?? '-';

            if (res?.error) {
                toast.danger(`收藏系列「${seriesTitle}」失敗`);
                console.log({ err: res.error });
            } else {
                toast.success(`收藏系列「${seriesTitle}」成功`);
            }

            await actionGetOrCreateUser(userId, JSON.stringify({ accessToken, lineId: userId }));

            redirect();
        };

        handleSeriesLink();
    }, [series, accessToken, actionGetOrCreateUser, actionLinkSeries, actionGetSeries, newSeriesId, toast, navigate, userId]);

    return null;
};
